import { ReactComponent as Chevron } from '../../assets/chevron.svg';

export default function FAQItem({ question, answer, isOpen, onToggle }) {
  return (
    <div>
      <button
        onClick={onToggle}
        className='group w-full px-6 py-4 text-left flex justify-between items-center hover:bg-white/8 transition duration-300'
      >
        <span className='text-white/60 group-hover:text-white text-lg transition duration-300'>
          {question}
        </span>
        <Chevron
          className={`w-4 h-4 text-white transition-transform duration-300 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className='px-6 pb-4'>
          <p className='text-white/60 text-13 leading-tight'>{answer}</p>
        </div>
      </div>
    </div>
  );
}
